<template>
    <system-page :page-settings="page">
        <div class="c-content">
            <error-msg class="u-text-bold">
                <p class="u-text-warning-icon">年齢制限により、当該大会には参加できません。</p>
            </error-msg>
            <div class="to-top">
                <router-link
                    :to="{name: 'EventTop'}"
                    class="c-btn c-btn-primary-outline"
                >
                    イベントトップへ
                </router-link>
            </div>
        </div>
    </system-page>
</template>

<script>
import SystemPage from '@/component/SystemPage.vue'
import errorMsg from '@/component/ErrorMsg.vue'

export default {
    name: 'QrLoginAgeErrorPage',
    components: {
        SystemPage,
        errorMsg
    },
    props: {},
    data: function() {
        return {
            page: {
                title: '年齢制限エラー',
                desc: 'ポケモンカードゲーム プレイヤーズクラブ 年齢制限エラーのページ。',
            },
        }
    },
}
</script>

<style lang="scss" scoped>
@use '~@/assets/style/global' as g;

.c-warningBox {
    width: g.$content-width-pc-sm;
    @include g.sp {
        width: 100%;
    }
}

.to-top {
    margin-top: 56px;
    line-height: 1;
    text-align: center;
    @include g.sp {
        margin-top: 48px;
    }
}
</style>
